import React from "react";
import { useTranslation } from "react-i18next";

export default function TotalPrize() {
    const { t } = useTranslation();
    return (
        <>
            <div className="font-evil text-brand-orange py-40 bg-brand-blue md:bg-brand-blue bg-cover bg-no-repeat bg-bottom w-full min-h-[50vh] md:min-h-[80vh] xl:min-h-screen flex justify-center items-center">
                {/* Centered box */}
                <div className="relative bg-white px-6 py-12 min-w-[75%] md:min-w-[60%] lg:min-w-[50%] flex flex-col justify-center items-center text-center">

                    {/* Floating orange title */}
                    <div className="absolute -top-5 left-1/2 -translate-x-1/2">
                        <div className="bg-brand-orange shadow-2xl inline-block px-8 py-2">
                            <p className="text-5xl 2xl:text-7xl text-white">
                                {t("home.prize.title")}
                            </p>
                        </div>
                    </div>

                    {/* Nominal (big prize number) */}
                    <span className="text-[8rem] md:text-[10rem] lg:text-[14rem] xl:text-[20rem] leading-[1.2] uppercase font-normal text-brand-orange pt-12 md:pt-0">
                        {t("home.prize.nominal")}
                    </span>

                    {/* Description */}
                    <span className="text-3xl lg:text-4xl xl:text-5xl leading-[1.1] uppercase font-normal text-brand-orange">
                        {t("home.prize.desc")}
                    </span>

                </div>
            </div>

        </>
    );
}
